import Vue from 'vue'
import Router from 'vue-router'
import home from './views/Home.vue';
import signup from './views/SignUp.vue';
import signin from './views/SignIn.vue';
import createprofile from './views/CreateProfile.vue';
import editprofile from './views/CreateProfile.vue'
import forgotpassword from './views/ForgotPassword.vue';
import changepassword from './components/ChangePassword.vue';
import uploadprofile from './views/UploadVideoProfile.vue';
import welcome from './views/WelcomePage.vue';
import notifications from './views/Notifications.vue'
import test from './views/test.vue';
import searchResults from './views/SearchResults.vue';
import selectedUser from './views/SearchSelectedUser.vue';
import selectedCompany from './views/companyprofile/SelectedCompanyProfile.vue'
// import MainLandingPage from './views/LandingPage/MajorLandingPage.vue'
import MainLandingPage from './views/LandingPage/MajorLandingPageNew.vue'
import LandingPage from './views/LandingPage/LandingPageNew.vue';
import HowItWorks from './views/LandingPage/HowitWorks.vue'
import Pricing from './views/LandingPage/Pricing.vue'
import People from './views/SuggestivePeople.vue';
import PrivacySettings from './views/PrivacySettings.vue';
import MainHome from './views/MainHomeVideos.vue'
import ProfileViews from './views/UserProfileViews.vue'
import VideoprofileViews from './views/UserVideoProfileViews.vue'
import Premium from './views/PremiumPlanSelection.vue'
import PaymentMethods from './views/PaymentMethods.vue'
import PurchaseHistory from './views/PurchaseHistory.vue'
import TermsandConditions from './views/TermsandConditions.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import JobsPage from './views/JobsPage.vue'
import RecordScreeningQuestions from './views/RecordScreeningQuestions.vue'
import TrackApplication from './views/TrackApplication.vue'
import SelectedTrackApplication from './views/SelectedJobTracking.vue'
import CloseAccount from './views/CloseAccount.vue'
import SelectedJobDetails from './components/SelectedJobDetails.vue'
import JobSearchList from './views/JobSearchList.vue'
import ReportIssue from './views/ReportIssue.vue'
import ReferandEarn from './views/ReferandEarn.vue'
import ContentCreators from './views/LandingPage/ContentCreators.vue'
import SelectedCompanyFollowersandFollowing from './components/SuggestivePeopleTabs/SelectedCompanyFollowersandFollowing.vue'
import selectedJobDetailsBeforeLogin from './views/LandingPage/LandingPageSelectedJob.vue'
import selectedUserProfilePageBeforeLogin from './views/LandingPage/LandingPageUserProfilePage.vue'
import StudentAmbassadorProgramme from './views/LandingPage/StudentAmbassadorProgramme.vue'
import InterestedInYou from './views/RequestedResumes.vue'
import SelectedResumeRequest from './components/SelectedRequestResume.vue'
//NotFound
import NotFound from './components/NotFound.vue'
//check
import MainComponent from './components/mainComponent.vue'
import store from './store.js'

//course
import CourseVideos from './views/CourseVideos.vue'

Vue.use(Router)

let router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: MainLandingPage
    },
    {
      path : '',
      name : 'maincomponent',
      component : MainComponent,
      children: [
        {
          path: '/welcome',
          name: 'welcome',
          component: welcome
        },
        {
          path: '/createprofile',
          name: 'createprofile',
          component: createprofile
        },
        {
          path: '/editprofile',
          name: 'editprofile',
          component: editprofile
        },
        {
          path: '/notifications',
          name: 'notifications',
          component : notifications
        },
        {
          path: '/wn/:id',
          name: 'wn',
          // component : selectedUser
          component : welcome
        },
        {
          path: '/wn/:id/:peopleType',
          name : 'selectedUserPeople',
          component : People
        },
        {
          path : '/wncompany/:id',
          name : 'wncompany',
          component : selectedCompany
        },
        {
          path : '/wncompany/:id/:peopleType',
          name : 'selectedCompanyPeople',
          component : SelectedCompanyFollowersandFollowing
        },
        {
          path: '/job-details',
          name: 'job_details',
          component : SelectedJobDetails
        },
        {
          path : '/job/view/:id',
          name : 'viewjob',
          component : SelectedJobDetails
        },
        {
          path: '/search-results/:searchType/:text',
          name: 'searchResults',
          component : searchResults
        },
        {
          path: '/jobslist',
          name: 'jobsList',
          component : JobSearchList
        },
        {
          path: '/close',
          name: 'close',
          component : CloseAccount
        },
        {
          path: '/jobs',
          name: 'job',
          component : JobsPage
        },
        {
          path:'/applyjob',
          name : 'recordScreeningQuestions',
          component : RecordScreeningQuestions
        },
        {
          path: '/track-applications',
          name: 'track',
          component : TrackApplication
        },
        {
          path : '/selected-job-tracking/:id',
          name : 'selectedJob',
          component : SelectedTrackApplication
        },
        {
          path: '/people',
          name: 'People',
          component : People
        },
        {
          path: '/privacy',
          name : 'privacy',
          component : PrivacySettings
        },
        {
          path: '/reportissue',
          name: 'reportissue',
          component : ReportIssue
        },
        {
          path: '/refer-and-earn',
          name: 'referandearn',
          component : ReferandEarn
        },
        {
          path: '/recruiter-requests',
          name: 'interestedinyou',
          component : InterestedInYou
        },
        {
          path: '/selected-resume-request/:id',
          name: 'selectedresumerequest',
          component : SelectedResumeRequest
        },
        {
          path: '/home',
          name: 'MainHome',
          component: MainHome
        },
        {
          path: '/course-videos',
          name: 'coursevideos',
          component: CourseVideos
        },
        {
          path: 'profile-views',
          name : 'profileViews',
          component : ProfileViews
        },
        {
          path : 'video-profile-views',
          name : 'videoProfileViews',
          component : VideoprofileViews
        },
        {
          path : 'premium',
          name : 'Premium',
          component : Premium
        },
        {
          path : 'payment-methods',
          name : 'payment_methods',
          component : PaymentMethods
        },
        {
          path : 'purchase-history',
          name : 'purchase_history',
          component : PurchaseHistory
        }
      ]
    },
    {
      path: '/test',
      name: 'homes',
      component: test
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/user',
      name: 'UserLandingPage',
      component: LandingPage
    },
    {
      path: '/how-worknotion-works',
      name: 'howitworks',
      component: HowItWorks
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    },
    {
      path: '/signin',
      name: 'signin',
      component: signin
    },
    {
      path : '/job/view/:id',
      name : 'selectedloginviewjob',
      component : selectedJobDetailsBeforeLogin
    },
    {
      path : '/wn/:id',
      name : 'selectedloginviewuserprofile',
      component : selectedUserProfilePageBeforeLogin
    },
    {
      path: '/forgot',
      name: 'forgotpassword',
      component: forgotpassword
    },
    {
      path: '/profile',
      name: 'changepassword',
      component: changepassword
    },
    {
      path : '/terms-and-conditions',
      name : 'terms_and_conditions',
      component : TermsandConditions
    },
    {
      path : '/privacy-policy',
      name : 'privacy_policy',
      component : PrivacyPolicy
    },
    {
      path : '/pricing',
      name :'pricing',
      component : Pricing
    },
    {
      path : '/content-creators',
      name :'content_creators',
      component : ContentCreators
    },
    {
      path : '/student-ambassador-programme',
      name :'student_ambassador_programme',
      component : StudentAmbassadorProgramme
    },
    // {
    //   path: '/invite/:id',
    //   redirect: '/signup'
    // },
    // {
    //   path: '/welcome',
    //   name: 'welcome',
    //   component: welcome
    // },
    // {
    //   path: '/createprofile',
    //   name: 'createprofile',
    //   component: createprofile
    // },
    // {
    //   path: '/editprofile',
    //   name: 'editprofile',
    //   component: editprofile
    // },
    {
      path: '/uploadprofile',
      name: 'uploadprofile',
      component: uploadprofile
    },
    { path: '*', component: NotFound }
    // {
    //   path: '/notifications',
    //   name: 'notifications',
    //   component : notifications
    // },
    // {
    //   path: '/selectedUser/:id',
    //   name: 'selectedUser',
    //   component : selectedUser
    // },
    // {
    //   path: '/searchResults/:text',
    //   name: 'searchResults',
    //   component : searchResults
    // },
	  // {
    //   path: '/people',
    //   name: 'People',
    //   component : People
    // },
    // {
    //   path: '/privacy',
    //   name : 'privacy',
    //   component : PrivacySettings
    // },
    // {
    //   path: '/mainHome',
    //   name: 'MainHome',
    //   component: MainHome
    // }
]
})
router.beforeEach((to, from, next) => {
  var isLoggedin = localStorage.getItem('isLoggedin')
  var userId = localStorage.getItem('user_id')
  var userprofileID = localStorage.getItem('profileId')
  // save job aliasname into session to display selected job with direct url
  if(to.name === 'viewjob'){
    const session = Vue.prototype.$session;
    session.set("selectedUserAliasname", null)
    session.set("selectedJodDetailsFromLogin", false)
    session.set("selectedJobAliasId", to.params.id);
  }
  // save user aliasname into session to display selected user with direct url
  if(to.name === 'selectedresumerequest'){
    const session = Vue.prototype.$session;
    session.set("selectedresumerequestId", to.params.id);
  }
  // save job aliasname into session to display selected job with direct url
  if(to.name === 'selectedJob'){
    const session = Vue.prototype.$session;
    session.set("selectedJobTrackingId", to.params.id);
  }
  // save company aliasname into session to display selected user with direct url
  if(to.name === 'wncompany'){
    const session = Vue.prototype.$session;
    session.set("selectedCompanyUserAliasname", to.params.id);
  }
  // save user aliasname into session to display selected user with direct url
  if(to.name === 'wn'){
    const session = Vue.prototype.$session;
    session.set("selectedJobAliasId", null)
    session.set("selectedJodDetailsFromLogin", false)
    session.set("selectedUserAliasname", to.params.id);
  }
  // save referral link into session to display in signup with direct url
  if(to.path.substring(1, 7) == 'invite'){
    const session = Vue.prototype.$session;
    session.set("referralLink", to.path.substring(8));
    next('signup')
  }else{
  if(to.path != '/signin' && to.path != '/' && to.path != '/signup' && to.path != '/forgot' && to.path != '/terms-and-conditions' && to.path != '/privacy-policy' 
  && to.path != '/pricing' && to.path != '/how-worknotion-works' && to.path != '/user' && to.path != '/content-creators' && to.path != '/student-ambassador-programme') {
      if(isLoggedin === "true" && userId) { 
        if(userprofileID){
          console.log('User already logged in', isLoggedin);
          next();
        }else{
          next('welcome')
        }
      } else {
          console.log("User didn't logged in", isLoggedin, to.name);
          if( to.name!="selectedloginviewjob" && to.name != "selectedloginviewuserprofile"){
          next('signin');
          }else{
            next()
          }
      }
  } else {
      // console.log('User on the login page');
      if(isLoggedin === "true" && userId){
        if(userprofileID){
          next('home')
        }else{
          next('welcome')
        }
      }else{
      next();
      }
  }
}
});
router.afterEach((to) => {
  gtag('config', window.GA_TRACKING_ID, {
    page_path: to.fullPath,
    app_name: 'Worknotion',
    send_page_view: true,
  });
});
router.afterEach((to, from) => {
  store.state.routeName = to.name;
})
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}
export default router;